import axios from "./api";

export const getLanguages = async (callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}languages`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//Simple Encryption and decryption functions

export function encode(str) {
  return str?.replace(/./g, function (c) {
    return ("00" + c.charCodeAt(0)).slice(-3);
  });
}

export function decode(str) {
  return str.replace(/.{3}/g, function (c) {
    return String.fromCharCode(c);
  });
}

export const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

//for Images fetching

export const imageUrl = (src) => {
  return process.env.GATSBY_IMAGE_URL + src;
};

export const twoDecimals = (data) => {
  return parseFloat(data).toFixed(2);
};

export const checkIfImageExists = (url, callback) => {
  const img = new Image();
  img.src = url;

  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => {
      callback(true);
    };

    img.onerror = () => {
      callback(false);
    };
  }
};

export const numberFormat = (str) => {
  if (str) {
    const twoDecimals = parseFloat(str).toFixed(2);
    return new Intl.NumberFormat("en-US").format(twoDecimals);
  } else {
    return 0;
  }
};

export const removeTags = (data) => {
  var txt = data;
  var rex = /(<([^>]+)>)/gi;
  return txt?.replace(rex, "");
};

export function capitalizeFirstLetter(string) {
  return string
    ?.split(" ")
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(" ");
}

export const getMember = () => {
  if (typeof window !== "undefined" && localStorage.getItem("member")) {
    if (localStorage.getItem("mimicmember")) {
      return JSON.parse(localStorage.getItem("mimicmember"));
    } else {
      return JSON.parse(localStorage.getItem("member"));
    }
  }
};

export const statusIdentifier = (data) => {
  if ((data >= 3 && data < 5) || data > 5) {
    const status = "Active";
    return status;
  }
  if (data === 5) {
    const status = "Archive";
    return status;
  }
  if (data === 1 || data === 2) {
    const status = "Pending";
    return status;
  }
};

export const hexToRGBA = (hex, alpha = 0.5) => {
  // Remove "#" if present
  hex = hex.replace(/^#/, "");

  // Convert shorthand hex (e.g. #f80) to full form (#ff8800)
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Parse r, g, b values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Return RGBA string
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const customStyles = {
  indicatorSeparator: (styles) => ({ display: "none" }),
  option: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "#47ad1d",
      color: "#fff",
    },
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: state.isSelected ? "#fff" : "black",
    backgroundColor: state.isSelected ? "#47ad1d" : provided.backgroundColor,
    maxHeight: "84px",
    //backgroundColor: state.isSelected ? "rgb(95, 50, 187, 10%)" : "white",
  }),
  control: (base, state) => ({
    ...base,
    height: 42,
    minHeight: 42,
    borderColor: state.isFocused ? "#47AD1D" : "#e4e4e4",
    boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    border: state.isHovered ? "0" : "1px solid #e4e4e4",

    "&:hover": {
      borderColor: state.isFocused ? "#47AD1D" : "0",
      boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    },
    // "&:focus": {
    //   borderColor: "#47AD1D",
    //   boxShadow: "0 0 0 0.5px #47AD1D"

    // },
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    "&:hover": {
      backgroundColor: "rgb(95, 50, 187, 10%)",
      color: "#6119c0",
    },
  }),
};
